var _ = require('lodash'),
  cache = require('../models/cache'),
  CONST_GENERAL = require('../constants/generalSettings'),
  deviceFingerprinterUtility = require('../utilities/deviceFingerprinterUtility'),
  htmlUtility = require('../utilities/htmlUtility'),
  log = require('../libraries/logger').getLoggerInstance('Base.FormParser');

var publicMethods = {
  parse: function () {
    try {
      var taggedElements = document.querySelectorAll('[' + CONST_GENERAL.CARDINAL_FIELD_ATTRIBUTE + ']');

      if (taggedElements != null && taggedElements.length > 0) {
        log.debug('Found [' + taggedElements.length + '] tagged elements');

        _.each(taggedElements, function (element) {
          try {
            var orderObjectField = element.getAttribute(CONST_GENERAL.CARDINAL_FIELD_ATTRIBUTE)
            cache.formFields[orderObjectField] = element;

            // FUTURE REVISION: Automatic form parsing to create an order object based off HTML attributes goes here
            switch (orderObjectField) {
              case 'AccountNumber':
                if(element.tagName.toLowerCase() === 'input'){
                  htmlUtility.inputListener.attach(element, deviceFingerprinterUtility.profileBinFromInput);
                }                
                cache.formFields.AccountNumber = element;
                break;
              
              default:
                break;
            }
          } catch (error) {
            log.debug('element type [' + element.type + '] data tag [' + element.getAttribute(CONST_GENERAL.CARDINAL_FIELD_ATTRIBUTE) + ']')
            log.error('Form processing failed: ' + error)
          }

        });

      } else {
        log.debug("No tagged elements found");
      }
    } catch (error) {
      log.error('Failure while parsing form' + error);
    }
  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/formParser.js
// module id = 111
// module chunks = 5